import { useEffect, useState } from "react";
import { Award } from "lucide-react";
import api from "@/lib/api";
import AIContentBlock from "@/components/AIContentBlock";

export default function HallOfFame() {
  const [inductees, setInductees] = useState([]);

  useEffect(() => {
    api.get("/hall-of-fame").then((r) => setInductees(r.data)).catch(console.error);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="hall-of-fame-page">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-slate-500 mb-3">Hall of Fame &amp; Memorials</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-slate-900">Honoring the <span className="gradient-text">Legends.</span></h1>
      <p className="mt-3 text-slate-600 max-w-2xl">MusicPulse editorial recognition — distinct from official institutional honors — with published criteria and community input.</p>

      <AIContentBlock pageKey="hall-of-fame" topic="Honoring music legends and preserving global musical heritage" imgQuery="legendary concert golden stage" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {inductees.map((h) => (
          <div key={h.id} className="card-lift bg-white rounded-3xl border border-slate-100 overflow-hidden" data-testid={`hof-card-${h.id}`}>
            <div className="h-44 overflow-hidden relative">
              <img src={h.image} alt={h.name} className="w-full h-full object-cover" />
              <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white/95 text-fuchsia-700 text-[10px] font-black uppercase tracking-wide">
                <Award className="w-3 h-3" /> {h.category}
              </span>
            </div>
            <div className="p-5">
              <h2 className="font-display text-xl font-black text-slate-900">{h.name}</h2>
              <p className="text-xs text-slate-500 mt-0.5">{h.region} · Inducted {h.inducted}</p>
              <p className="text-sm text-slate-600 mt-3 italic">"{h.citation}"</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
